














import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

import { DropTarget } from "vue-react-dnd";


/**
 * Components
 */

const DropTargetImpl = {
	dropTarget: {
		type() {
			const that = this as any as DropArea;
			return that.type;
		},
		specs: {
			drop(monitor: any) {
				const that = this as any as DropArea;
				that.onDrop(monitor.getItem(), that.role);
			}
		},
		collect(connect: any, monitor: any) {
			const that = this as any as DropArea;

			that.isOver = monitor.isOver();
			that.canDrop = monitor.canDrop();
		}
	}
};


/**
 * A drop area component in a group card component.
 */
@Component({
	mixins: [DropTarget, DropTargetImpl]
})
export default class DropArea extends Vue {
	/// Properties
	@Prop({default: ""})
	type!: string;

	@Prop({type: Boolean})
	isActive!: boolean;

	@Prop({default: ""})
	role!: string;

	@Prop()
	onDrop!: (item: any, newRole: string) => void;

	/// Attributes
	isOver = false;
	canDrop = false;
}
